import { GoogleButton } from './containers/GoogleButton'
import reducer from './reducer'

export { GoogleButton, reducer }



// WEBPACK FOOTER //
// ./client/Modules/AuthGoogle/index.js